/**
 * This file was copied from dashboard into clowncar as part of a cleanup effort
 */
import * as React from 'react';
import { reduxForm } from 'redux-form';

import BaseComponent from '@tock/shared/components/BaseComponent';
import Button from '@tock/shared/components/buttons/DeprecatedButton';
import Field from '@tock/shared/components/forms/Field';
import Fieldset from '@tock/shared/components/forms/Fieldset';
import Form from '@tock/shared/components/forms/Form';
import TextInput from '@tock/shared/components/inputs/DeprecatedTextInput';

const asyncValidate = (values: Fields) => {
  return new Promise<void>((resolve, reject) => {
    if (!(values.email && values.password)) {
      reject({ _error: 'Please enter an email and password.' });
    } else {
      resolve();
    }
  });
};

interface Fields {
  email: string;
  password: string;
}

interface Props {
  forgotPasswordLink?: JSX.Element;
}

class LoginForm extends BaseComponent<Props & ReduxFormProps<Fields>> {
  componentDidMount() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (this.refs as any).email.focus();
  }

  render() {
    const {
      fields: { email, password },
      error,
      handleSubmit,
      submitting,
    } = this.props;

    const onSubmitHelper = (event: React.FormEvent<HTMLFormElement>) => {
      // Make extra sure that we don't put the password in the URL querystring
      event.preventDefault();
      handleSubmit(event);
    };

    return (
      <Form onSubmit={onSubmitHelper}>
        <Fieldset>
          {error && (
            <div className="Errors Errors--form">
              <div className="Error">{error}</div>
            </div>
          )}

          <Field field={email}>
            <TextInput
              field={email}
              placeholder="Email address"
              ref="email"
              type="email"
              data-testid="login-email-input"
            />
          </Field>

          <Field className="Field--flex" field={password}>
            <TextInput
              field={password}
              placeholder="Password"
              modifierClassName="TextInput--default TextInput--login"
              type="password"
              data-testid="login-password-input"
            />
            {this.props.forgotPasswordLink}
          </Field>
        </Fieldset>

        <div className="FormActions">
          <Button
            disabled={submitting}
            modifierClassName="FormAction"
            type="submit"
            variant="primary"
            data-testid="login-submit-button"
          >
            Log in
          </Button>
        </div>
      </Form>
    );
  }
}

export default reduxForm<Props, Fields>({
  form: 'LoginForm',
  fields: ['email', 'password'],
  initialValues: {
    email: '',
    password: '',
  },
  asyncValidate,
})(LoginForm);
